// O que os dois documentos dividem: o e-mail, as datas e os jeitos de escrever valores das constantes.
import { emReais, planosQueTem, type RecursoSimNao } from '@truco6/planos';

export const EMAIL_OFICIAL = 'contato@trucode6.com.br';

// Data de cada documento (AAAA-MM-DD): muda junto com o texto, no dia do deploy. O jogo e o site mostram 18/10/2026.
export const TERMOS_ATUALIZADOS = '2026-10-31';
export const PRIVACIDADE_ATUALIZADA = '2026-10-31';
export const dataBr = (iso: string): string => iso.split('-').reverse().join('/');

// Os avisos no celular, na ordem da tela Configurações (apps/jogo/src/comum/push.ts confere a lista).
export const AVISOS_NO_CELULAR = [
  'Chamado para a mesa', 'Pedido de amizade e convite de trio', 'Ofensiva', 'Ranking da semana', 'Comunidade e campeonato',
] as const;

// "a, b e c" (ou "a, b ou c").
export function lista(itens: (string | number)[], conjuncao = 'e'): string {
  const xs = itens.map(String);
  return xs.length > 1 ? `${xs.slice(0, -1).join(', ')} ${conjuncao} ${xs.at(-1)}` : xs[0] ?? '';
}
// R$ 150 em vez de R$ 150,00 para valor redondo.
export const reaisRedondo = (centavos: number): string => (centavos % 100 === 0 ? `R$ ${centavos / 100}` : emReais(centavos));
export const dias = (n: number): string => `${n} ${n === 1 ? 'dia' : 'dias'}`;
export const horas = (n: number): string => `${n} ${n === 1 ? 'hora' : 'horas'}`;
export const duracao = (min: number): string => (min % 60 === 0 ? horas(min / 60) : `${min} minutos`);
// "No plano Ouro" ou "Nos planos Prata e Ouro" (ou com minúscula, no meio da frase).
export function nosPlanos(recurso: RecursoSimNao, maiuscula = true): string {
  const nomes = planosQueTem(recurso), t = nomes.includes(' e ') ? `nos planos ${nomes}` : `no plano ${nomes}`;
  return maiuscula ? t[0]!.toUpperCase() + t.slice(1) : t;
}

export interface OpcoesDoDocumento {
  // O começo dos links do site (/privacidade, /termos): vazio no jogo e no HTML do site, o endereço completo no Markdown
  // que sai sozinho.
  base?: string;
}
